import cn from "classnames"
import React from "react"

import { NewsItemType } from "~/api/types/NewsList"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { Label } from "./components/Label/Label"
import styles from "./index.module.css"

type Props = NewsItemType & {
  className?: string
  slug?: string
  isBig?: boolean
}

export const CardNews: React.FC<Props> = ({
  className,
  name,
  previewPicture,
  previewText,
  code,
  logo,
  video,
  date,
  gallery,
  slug,
  isBig,
  type,
}) => {
  return (
    <Card
      className={cn(styles.ItemWrapper, className, { [styles.Big]: isBig })}
      link={
        type !== "ir" ? `/press/${slug}/${code}` : `/investors-and-shareholders/ir-blog/${code}`
      }
    >
      {previewPicture && (
        <div className={styles.Image}>
          <img src={previewPicture} />
        </div>
      )}

      <div
        className={cn(styles.Inner, {
          [styles.InnerBigWithoutImage]: !previewPicture,
        })}
      >
        <Heading className={styles.Title} like="h4">
          <Raw html={name} />
        </Heading>

        {!previewPicture && previewText && isBig && (
          <div className={styles.Description} dangerouslySetInnerHTML={{ __html: previewText }} />
        )}
      </div>

      <div
        className={cn(styles.Fade, {
          [styles.FadeBigWithoutImage]: !previewPicture,
        })}
      >
        <Label date={date} gallery={gallery} video={video} />
      </div>
    </Card>
  )
}
